import { render, staticRenderFns } from "./LessonsListHtml.vue?vue&type=template&id=72427aec&scoped=true&"
import script from "./LessonsListHtml.vue?vue&type=script&lang=js&"
export * from "./LessonsListHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72427aec",
  null
  
)

export default component.exports